import { Progress } from "@/src/components/ui/progress";
import { Card } from "@/src/components/wrappers/Card";

const CustomerPaymentBarSection = ({ paymentScheduleData }: { paymentScheduleData: any }) => {
  const totalPaid = paymentScheduleData?.data?.reduce(
    (acc: number, item: { paidSoFar: number }) => acc + item.paidSoFar,
    0,
  );
  const totalBookingAmount = parseFloat(paymentScheduleData?.data?.[0]?.bookingAmount || "0");
  const progress = totalBookingAmount > 0 ? Math.round((totalPaid / totalBookingAmount) * 100) : 0;
  const currency = paymentScheduleData?.data?.[0]?.booking?.currency?.code || "GBP";

  const formatPrice = (price: number, toCurrency: string) => {
    const formattedNumber = new Intl.NumberFormat("en-EN", { style: "currency", currency: toCurrency }).format(price);

    return `${formattedNumber}`;
  };

  return (
    <Card className="w-full flex flex-col gap-y-6">
      <p className="text-base font-medium">
        Customer paid {formatPrice(totalPaid, currency)} out of {formatPrice(totalBookingAmount, currency)} ({progress}
        %)
      </p>
      <Progress value={progress} />
    </Card>
  );
};

export default CustomerPaymentBarSection;
